(function () {
  // Klaviyo form ID from the Custom trigger box
  var FORM_ID = 'REGySP';
  var SESSION_KEY = 'kl_exit_form_shown_' + FORM_ID; // unique per form
  var fired = false;

  function openKlaviyoForm() {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', FORM_ID]);
  }

  function fireOncePerSession() {
    if (fired) return;
    if (sessionStorage.getItem(SESSION_KEY) === '1') return;

    fired = true;
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
    openKlaviyoForm();

    // stop listening after first show
    document.removeEventListener('mouseout', onExitIntent, false);
  }

  function onExitIntent(e) {
    // classic desktop exit intent: leaving viewport at the top edge
    var leavingToNowhere = !e.relatedTarget && !e.toElement;
    if (leavingToNowhere && e.clientY <= 0) {
      fireOncePerSession();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('mouseout', onExitIntent, false);
  });
})();